import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Start a new loan calculation ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCirclePlus = _resolveComponent("IconCirclePlus")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!

  return (_openBlock(), _createBlock(_component_PrimaryButton, { size: "lg" }, {
    default: _withCtx(() => [
      _createVNode(_component_IconCirclePlus, { class: "h-6 w-6" }),
      _hoisted_1
    ]),
    _: 1
  }))
}